/** Borderless root shell — group hover drives preview border. */
export const gridCardRootClassName =
  "group relative flex flex-col gap-2 text-left bg-transparent shadow-none border-0 rounded-none overflow-visible focus-visible:outline-none";

/** Bordered preview well (16:10). Hover border via parent `group`. */
export const gridCardPreviewClassName =
  "relative w-full aspect-[16/10] overflow-hidden rounded-md border border-border bg-surface-card transition-colors duration-200 ease-out group-hover:border-border-hover";

/** Rust ring on the preview shell (selection + keyboard focus). */
export const gridCardPreviewHighlightedClassName =
  "border-rust ring-2 ring-rust group-hover:border-rust";

/** Selection ring on the preview shell. */
export const gridCardPreviewSelectedClassName =
  gridCardPreviewHighlightedClassName;

/** Keyboard focus ring on the preview shell (parent must be focusable). */
export const gridCardPreviewFocusedClassName =
  "group-focus-visible:border-rust group-focus-visible:ring-2 group-focus-visible:ring-rust group-focus-visible:group-hover:border-rust";

/** Dashed-border variant for create / upload placeholder preview wells. */
export const dashedGridCardPreviewClassName =
  "border-2 border-dashed border-border group-hover:border-border-hover";

/** 2×2 canvas thumbnail grid inside the preview well (1px dividers). */
export const gridCardPreviewGridClassName =
  "absolute inset-0 grid grid-cols-2 grid-rows-2 gap-px bg-border transition-colors duration-200 ease-out group-hover:bg-border-hover";

/** Centered preview glyph (plus, folder, image, chat bubble, …). */
export const gridCardPreviewPlaceholderIconClassName =
  "h-10 w-10 text-muted-foreground";

/** Floating footer below the preview — no border or card surface. */
export const gridCardFooterClassName =
  "flex min-w-0 items-start justify-between gap-2 px-0.5 pb-1";

/** Footer title line (name / primary label). */
export const gridCardFooterTitleClassName =
  "truncate text-sm font-semibold leading-tight text-foreground";

/** Footer secondary line (timestamp, metadata, status). leading-tight (not
 *  leading-none): a 1.0 line box clips descenders ("ago", "g", "y"). */
export const gridCardFooterSubtitleClassName =
  "text-sm leading-tight text-muted-foreground";

/** Offset between footer title row and metadata row. */
export const gridCardFooterMetaRowClassName = "mt-2";

/** Pointer cursor for clickable grid tiles. */
export const interactiveGridCardClassName = "cursor-pointer";

/** @deprecated Use gridCardRootClassName — kept for external re-exports. */
export const gridCardClassName = gridCardRootClassName;

/** @deprecated Use dashedGridCardPreviewClassName. */
export const dashedGridCardClassName = dashedGridCardPreviewClassName;
